<template>
    <v-content app class="grey lighten-4">
        <v-container fluid class="px-8 py-6">
            <router-view></router-view>
        </v-container>
    </v-content>
</template>

<script>
export default {
    name: 'Content',
}
</script>

<style>

</style>
